<template>
  <div class="row">
    <div class="col-auto min-w-250px mb-4">
      <div class="fv-row">
        <Multiselect
          :id="`multiselect${id}`"
          :ref="`multiselect${id}`"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Selecione o campo à ser filtrado"
          v-model="this.regraFiltro.campo"
          :searchable="true"
          :canDeselect="true"
          :options="this.camposOrdenados(this.model)"
          placeholder="Selecione um campo"
          @clear="this.focusSelect(`multiselect${this.id}`)"
          @select="
            this.regraFiltro.operador === ``
              ? this.focusSelect(`multiselectOperadores${this.id}`)
              : nextFocus(`multiselectValor${id}`)
          "
        >
          <template v-slot:singlelabel="{ value }">
            <div class="multiselect-single-label">
              {{ value.label }}
            </div>
          </template>
          <template v-slot:option="{ option }">
            {{ option.label }}
          </template>
          <template v-slot:noresults="{}">
            <div class="m-4">
              {{ "Nenhum resultado foi encontrado" }}
            </div>
          </template>
        </Multiselect>
      </div>
    </div>
    <div
      v-if="this.regraFiltro.campo && this.regraFiltro.tipo != 'object'"
      class="col-auto min-w-250px mb-4"
    >
      <div class="fv-row">
        <Multiselect
          :id="`multiselectOperadores${id}`"
          :ref="`multiselectOperadores${id}`"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Informe a condição à ser aplicada"
          v-model="this.regraFiltro.operador"
          :searchable="true"
          :canDeselect="true"
          :options="this.retornaOperadores()"
          placeholder="Selecione uma opção"
          @clear="this.focusSelect(`multiselectOperadores${this.id}`)"
          @select="nextFocus(`multiselectValor${id}`)"
        >
          <template v-slot:singlelabel="{ value }">
            <div class="multiselect-single-label">
              {{ value.label }}
            </div>
          </template>
          <template v-slot:option="{ option }">
            {{ option.label }}
          </template>
          <template v-slot:noresults="{}">
            <div class="m-4">
              {{ "Nenhum resultado foi encontrado" }}
            </div>
          </template>
        </Multiselect>
      </div>
    </div>
    <div class="col-auto mb-4">
      <div class="d-flex flex-row">
        <div
          v-if="
            this.inputValido &&
            this.regraFiltro.campo &&
            this.regraFiltro.tipo != 'object'
          "
          class="d-flex flex-column-fluid"
        >
          <input
            v-if="this.inputNumber"
            :id="`multiselectValor${id}`"
            :ref="`multiselectValor${id}`"
            type="number"
            class="form-control form-control-sm mb-0"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            placeholder="Insira um valor numérico"
            v-model="this.regraFiltro.valor"
            v-on:keyup.enter="this.aplicarFiltro()"
          />
          <CurrencyInput
            v-else-if="this.inputDecimal"
            :id="`multiselectValor${id}`"
            :ref="`multiselectValor${id}`"
            class="form-control form-control-sm mb-0"
            placeholder="Insira um valor numérico"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            style="text-align: right"
            v-model="this.regraFiltro.valor"
            :options="options"
            v-on:keyup.enter="this.aplicarFiltro()"
          ></CurrencyInput>
          <el-date-picker
            v-else-if="this.inputDate"
            :id="`multiselectValor${id}`"
            :ref="`multiselectValor${id}`"
            type="datetime"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            placeholder="Informe uma data"
            format="DD/MM/YYYY"
            class="mw-200px"
            v-model="this.regraFiltro.valor"
            v-on:keyup.enter="this.aplicarFiltro()"
          />
          <el-date-picker
            v-else-if="this.inputDateTime"
            :id="`multiselectValor${id}`"
            :ref="`multiselectValor${id}`"
            type="datetime"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            placeholder="Informe uma data"
            format="DD/MM/YYYY HH:mm:ss"
            class="mw-200px"
            v-model="this.regraFiltro.valor"
            v-on:keyup.enter="this.aplicarFiltro()"
          />
          <input
            v-else-if="this.inputText"
            :id="`multiselectValor${id}`"
            :ref="`multiselectValor${id}`"
            type="text"
            class="form-control form-control-sm mb-0"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            placeholder="Informe o valor"
            v-model="this.regraFiltro.valor"
            v-on:keyup.enter="this.aplicarFiltro()"
          />
        </div>
        <div v-if="this.showRemove" class="col-auto">
          <div class="fv-row">
            <button
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Remover regra"
              class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-danger svg-icon-white px-2 pb-2"
              :class="[
                this.inputValido &&
                  this.regraFiltro.campo &&
                  this.regraFiltro.tipo != 'object' &&
                  `ms-4`,
              ]"
              @click="this.$emit(`removerRegra`)"
            >
              <i class="la la-trash-o ms-1 fs-2"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="
          this.inputValido &&
          this.regraFiltro.campo &&
          (this.regraFiltro.operador === 'between' ||
            this.regraFiltro.operador === 'notbetween')
        "
        class="d-flex flex-row mt-4"
      >
        <div class="d-flex flex-column-fluid">
          <input
            v-if="this.inputNumber"
            type="number"
            class="form-control form-control-sm mb-0"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            placeholder="Insira um valor numérico"
            v-model="this.regraFiltro.valor_entre"
            v-on:keyup.enter="this.aplicarFiltro()"
          />
          <CurrencyInput
            v-else-if="this.inputDecimal"
            class="form-control form-control-sm mb-0"
            placeholder="Insira um valor numérico"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            style="text-align: right"
            v-model="this.regraFiltro.valor_entre"
            :options="options"
            v-on:keyup.enter="this.aplicarFiltro()"
          ></CurrencyInput>
          <el-date-picker
            v-else-if="this.inputDateTime"
            type="datetime"
            class="mw-200px"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Insira a informação que deseja filtrar"
            placeholder="Informe uma data"
            format="DD/MM/YYYY HH:mm:ss"
            v-model="this.regraFiltro.valor_entre"
            v-on:keyup.enter="this.aplicarFiltro()"
          />
        </div>
        <div v-if="this.showRemove" class="col-auto ms-4 px-6"></div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-auto">
      <DynamicQueryBuilder
        v-if="this.regraFiltro.regra"
        :regra="this.regraFiltro.regra"
        :model="
          (this.regraFiltro.operador === 'object' ||
            this.regraFiltro.operador === 'array') &&
          this.model[this.regraFiltro.campo].items
            ? this.model[this.regraFiltro.campo].items
            : this.model[this.regraFiltro.campo]
        "
        :operadores="this.operadores"
        :showRemove="false"
      />
    </div>
  </div>
</template>

<script>
import CurrencyInput from "@/components/text/CurrencyInput";
import Multiselect from "@vueform/multiselect";
import $bus from "@/utils/event.js";

export default {
  name: "DynamicQueryBuilder",
  emits: ["removerRegra"],
  components: {
    CurrencyInput,
    Multiselect,
  },
  props: {
    regra: { type: Object, required: true },
    model: { type: Object, required: true },
    operadores: { type: Object, required: true },
    showRemove: { type: Boolean, required: false, default: true },
  },
  methods: {
    async nextFocus(id) {
      await this.sleep(100);
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async aplicarFiltro() {
      await this.sleep(100);
      $bus.trigger("aplicar-select-filter");
    },
    async focusSelect(campo) {
      await this.sleep(100);
      var element = this.$refs[campo];
      if (element) {
        element.open();
      }
    },
    camposOrdenados(objeto) {
      const compararPorDescricao = (a, b) => {
        const descricaoA = a.descricao.toUpperCase();
        const descricaoB = b.descricao.toUpperCase();

        if (descricaoA < descricaoB) return -1;
        if (descricaoA > descricaoB) return 1;
        return 0;
      };

      const arrayDePares = Object.entries(objeto);

      arrayDePares.sort((a, b) => compararPorDescricao(a[1], b[1]));

      const objetoOrdenado = Object.fromEntries(arrayDePares);

      const transformedJson = [];
      for (const key in objetoOrdenado) {
        transformedJson.push({
          value: key,
          label: objetoOrdenado[key].descricao,
          objeto: objetoOrdenado[key],
        });
      }

      return transformedJson;
    },
    retornaOperadores() {
      const transformedJson = [];

      for (const operador of this.operadores[this.regraFiltro.tipo]) {
        transformedJson.push({
          value: operador.valor,
          label: operador.descricao,
          objeto: operador,
        });
      }

      return transformedJson;
    },
    atualizarTipo() {
      let newTipo = this.retornaTipoCampo(this.regraFiltro.campo);

      if (this.regraFiltro.tipo != newTipo) {
        if (this.regraFiltro.tipo === "object") {
          delete this.regraFiltro.regra;
        }
        this.regraFiltro.valor = "";
        this.regraFiltro.valor_entre = "";
      }

      this.regraFiltro.tipo = newTipo;
      this.validarOperador();
      this.validarInput();
    },
    retornaTipoCampo(campo) {
      const tipo = this.model[campo]
        ? this.model[campo].tipo || "unknown"
        : "unknown";

      const tipoComplementar = this.model[campo]
        ? this.model[campo].tipoComplementar || "unknown"
        : "unknown";

      if (tipoComplementar.toUpperCase().includes("UTC")) {
        this.regraFiltro.utc = true;
      } else {
        this.regraFiltro.utc = false;
      }

      if (tipo === "object" || tipo === "array") {
        this.regraFiltro.operador = tipo;
        if (!this.regraFiltro.regra) {
          this.regraFiltro.regra = {
            campo: "",
            operador: "",
            tipo: "",
            valor: "",
            valor_entre: "",
            utc: false,
          };
        }
        return "object";
      } else if (tipo.toUpperCase().includes("INT")) {
        return "number";
      } else if (tipo.toUpperCase().includes("STRING")) {
        return "text";
      } else if (tipo.toUpperCase().includes("DATETIME")) {
        return "datetime";
      } else if (tipo.toUpperCase().includes("DECIMAL")) {
        return "decimal";
      } else {
        return "text";
      }
    },
    validarOperador() {
      const tipoOperadores = this.operadores[this.regraFiltro.tipo];
      const valorExiste = tipoOperadores.some(
        (operador) => operador.valor === this.regraFiltro.operador
      );

      if (!valorExiste) {
        this.regraFiltro.operador = "";
        this.focusSelect(`multiselectOperadores${this.id}`);
      }
    },
    validarInput() {
      this.inputNumber = false;
      this.inputDecimal = false;
      this.inputDate = false;
      this.inputDateTime = false;
      this.inputText = false;
      this.inputValido = false;

      let tipo = this.regraFiltro.tipo;
      let operador = this.regraFiltro.operador;

      const operadoresInvalidos = [
        "isempty",
        "isnotempty",
        "isnull",
        "isnotnull",
        "object",
      ];

      if (!operadoresInvalidos.includes(operador)) {
        this.inputValido = true;
        if (tipo === "number") {
          if (operador === "in" || operador === "notin") {
            this.inputText = true;
          } else {
            this.inputNumber = true;
          }
        } else if (tipo === "decimal") {
          if (operador === "in" || operador === "notin") {
            this.inputText = true;
          } else {
            this.inputDecimal = true;
            if (this.regraFiltro.valor.toString() === "") {
              this.regraFiltro.valor = 0;
            }
          }
        } else if (tipo === "datetime") {
          if (operador === "equal" || operador === "notequal") {
            this.inputDate = true;
          } else {
            this.inputDateTime = true;
          }
        } else {
          this.inputText = true;
        }
      }
    },
  },
  watch: {
    regra: {
      handler(newRegra) {
        this.regraFiltro = this.regra;
      },
      deep: true,
    },
    "regra.campo": {
      handler(newRegra) {
        this.atualizarTipo();
      },
    },
    "regra.operador": {
      handler(newRegra) {
        this.atualizarTipo();
      },
    },
  },
  async mounted() {
    this.regraFiltro = this.regra;
    this.atualizarTipo();
    if (this.regraFiltro.campo === "") {
      this.focusSelect(`multiselect${this.id}`);
    }
  },
  data() {
    return {
      id: this.$utils.getRandomIntInclusive(0, 1000),
      inputValido: false,
      inputNumber: false,
      inputDecimal: false,
      inputDate: false,
      inputDateTime: false,
      inputText: false,
      regraFiltro: {},
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style>
.multiselect > * {
  font-size: 0.925rem;
  border-radius: 0.425rem;
  font-weight: 500;
  line-height: 1.5;
}
.multiselect-option.is-pointed.is-selected {
  background: hwb(219 31% 26%);
}
.multiselect-option.is-selected {
  background: hwb(219 31% 26%);
}
.is-single .multiselect-search input {
  padding: 0px 0px 0px 14px;
  font-size: 0.925rem;
}
.multiselect-input {
  min-height: 34px;
}
.multiselect-single-label {
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap !important;
  max-width: 200px !important;
  padding-right: 10px !important;
}
.multiselect-input input {
  min-height: 34px;
}
.multiselect-clear {
  position: absolute;
  right: 4px;
  top: 50%;
  width: 34px;
  height: 34px;
  background: transparent;
}
</style>
